import { Client } from '../core/src/models/client'

/*
 * Shared features module for client feature management.
 * This module defines the structure and utility functions for handling client features.
 */

export enum FeatureStatus {
	ENABLED = 'enabled',
	DISABLED = 'disabled',
	BETA = 'beta'
}

export enum Features {
	CONTRACT_TAGS = 'contract-tags',
	TRADE_HUB = 'trade-hub',
	TRADE_HUB_PRICE_TYPE = 'trade-hub-price-type',
	TRADE_HUB_ADDITIONAL_SETTINGS = 'trade-hub-additional-settings',
	BRAZE_EVENTS = 'braze-events',
	DWH_CONTRACTOR_EXPORT = 'dwh-contractor-export',
	SYNC_EXTERNAL_PRODUCT_CHANNELS = 'sync-external-product-channels',
	REBOOKING = 'rebooking',
	MS_SSO = 'ms-sso',
	REGISTRATION_CAPTCHA = 'registration-captcha',
	OPERATORS = 'operators',
	AI_COPILOT = 'ai-copilot',
	CONTINGENT_THRESHOLD = 'contingent-threshold',
	// MYS-7512: English instead of German is the required content language (interim, German-only outputs remain)
	ENGLISH_CONTENT = 'english-content',
}

export function clientHasFeature(client: Client, feature: Features): boolean {
	const featureInList = client.fields?.features?.de?.find(f => f.id === feature)
	return Boolean(featureInList && featureInList.status === FeatureStatus.ENABLED)
}